import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Core
import { RootStoreProvider } from './core/stores/RootStore';
import { AuthProvider } from './core/auth/AuthProvider';
import ProtectedRoute from './core/router/ProtectedRoute';

// Shared Components
import AppLayout from './shared/components/AppLayout';

// Apps
import AdminRoutes from './context/admin/routes';
import ProctorRoutes from './context/proctor/routes';
import TestTakerRoutes from './context/testTaker/routes';
import FacultyRoutes from './context/faculty/routes';
import PublicRoutes from './context/public/routes';
import ElementsRoutes from './context/elements/routes';
import VTCRoutes from './context/vtc/routes';
import SessionRoutes from './context/session/routes';
import BlockKitRoutes from './context/blockkit/routes';

// Auth Pages
import LoginPage from './core/auth/pages/LoginPage';

function App() {
  return (
    <BrowserRouter>
      <RootStoreProvider>
        <AuthProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/public/*" element={<PublicRoutes />} />
              <Route path="/blockkit/*" element={<BlockKitRoutes />} />

              {/* Elements Routes - No authentication or layout required */}
              <Route path="/elements/*" element={<ElementsRoutes />} />

              <Route path="/vtc/*" element={<VTCRoutes />} />

              <Route path="/session/*" element={<SessionRoutes />} />
              {/* Protected Routes */}
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                {/* Admin Routes */}
                <Route path="/admin/*" element={<AdminRoutes />} />

                {/* Proctor Routes */}
                <Route path="/proctor/*" element={<ProctorRoutes />} />

                {/* Test Taker Routes */}
                <Route path="/test-taker/*" element={<TestTakerRoutes />} />

                {/* Faculty Routes */}
                <Route path="/faculty/*" element={<FacultyRoutes />} />

                {/* Default Redirect */}
                <Route path="/" element={<Navigate to="/public/login" replace />} />
                <Route path="*" element={<Navigate to="/public/login" replace />} />
              </Route>
            </Routes>
          </AuthProvider>
      </RootStoreProvider>
    </BrowserRouter>
  );
}

export default App;
